import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Dashboard, SaveDashboard } from '../types/types';
import { DataContext, NotificationContext } from '../App';
import { DashboardForm } from '../components';
import useErrorHandler from '../hooks/useErrorHandler';
import Frame from '../layout/Frame';
import { updateDashboard, fetchDashboardDetails } from '../requests/requests';
import { AppRoute, SnackbarType } from '../types/enums';
import Panel from '../layout/Panel';

const EditDashboard = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const errorHandler = useErrorHandler();
  const notify = useContext(NotificationContext);
  const { refreshDashboards } = useContext(DataContext);
  const [details, setDetails] = useState<Dashboard>();

  useEffect(() => {
    if (id) {
      fetchDashboardDetails(id)
        .then(({ data }) => {
          setDetails(data);
        })
        .catch(() => {
          navigate(AppRoute.DASHBOARDS);
        });
    } else {
      navigate(AppRoute.DASHBOARDS);
    }
  }, []);

  const onSubmit: SaveDashboard = useCallback(
    (payload) => {
      if (id) {
        updateDashboard(id, payload).then((res) => {
          if (res.data) {
            notify('Dashboard updated successfully', SnackbarType.SUCCESS);
            refreshDashboards();
            navigate(AppRoute.DASHBOARDS);
          }
        }, errorHandler);
      }
    },
    [id]
  );

  return (
    <Frame>
      <Panel>
        <h1>Edit dashboard</h1>
        {details && <DashboardForm onSave={onSubmit} initialValues={details} />}
      </Panel>
    </Frame>
  );
};

export default EditDashboard;
